import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemRepositoryService } from '../../services/item-repository.service';
import { map, combineLatest, BehaviorSubject, filter, first } from 'rxjs';
import iconSrc from '!!file-loader!./catalog-pdf.svg';
import { AppointmentServiceType } from '@medindex-webapi';

@Component({
  selector: 'app-catalog-item-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionComponent {
  iconSrc = iconSrc;
  visibleBiomaterials$ = new BehaviorSubject(3);

  constructor(public repository: ItemRepositoryService) {}

  showBiomaterialTable$ = combineLatest([
    this.repository.nomenclature$,
    this.repository.appointmentType$,
  ]).pipe(
    map(([nomenclature, appointmentType]) => {
      if (!nomenclature) return false;

      return (
        nomenclature.biomaterialRules &&
        nomenclature.biomaterialRules.length > 0 &&
        appointmentType !== AppointmentServiceType.Covid &&
        appointmentType !== AppointmentServiceType.DoublePcr
      );
    })
  );

  setMaxVisibleBiomaterials(): void {
    this.repository.nomenclature$
      .pipe(
        filter((nomenclature) => !!nomenclature),
        first()
      )
      .subscribe((nomenclature) => {
        const maxLength = nomenclature?.biomaterialRules?.length ?? 0;
        this.visibleBiomaterials$.next(maxLength);
      });
  }
}
